import React from 'react'
import FiveDBall from './FiveDBall'
const K3Balls = ({ addStake }) => {

  function addBall(ball){
    addStake(ball)
    console.log(ball)
  }

  return (
    <div className='bg-white rounded-lg grid grid-cols-5 gap-6 p-2 '>
      {Array.from({ length: 10 }, (_, i) => (
        <FiveDBall i={i} addBall={addBall}/>
        ))}
      </div>
  )
}

export default K3Balls